const CONFIG = {
  // API_HOST: "https://lifenutrition.innothink-tech.com/dev/oes_api",
  // SITE_DOMAIN: "https://lifenutrition.innothink-tech.com/dev/site"

  // API_HOST: "https://lifenutrition.innothink-tech.com/oes_api",
  API_HOST: "https://corp.lifenutrition.com/api",
  SITE_DOMAIN: "https://corp.lifenutrition.com"
};

export { CONFIG };